define([
	"csi/access/_base",
	"csi/access/access",
	"csi/access/full"
], function (csiAccess, access, full) {

	const dataPackageAdminRoles = ['TDS - Data Package Administrator'];

	const foodAdmin = ['Food Administrator'];
	const foodEditor = foodAdmin.concat(['Food Editor']);

	const hierarchyAdminRoles = ['Hierarchy Administrator'];
	const hierarchyEditRoles = hierarchyAdminRoles.concat(['Hierarchy Editor', 'Hierarchy Library Administrator']);

	const leafFolderAdminRoles = ['Leaf Folder Administrator'];

	const productSampleAdmin = ['Sample Administrator'];
	const productSpecAdminRoles = ['Product Specification Administrator'];
	const productSpecEditorRoles = productSpecAdminRoles.concat(['Product Specification Editor']);
	const productSpecLibAdminRoles = ['Product Specification Library Administrator', 'Product Specification Administrator'];
	const foodLabelCreator = productSpecAdminRoles.concat(['TDS - Food Label Administrator', 'TDS - Food Label Creator']);
	const foodLabelEditor = foodLabelCreator.concat(['TDS - Food Label Editor']);

	const bomCreatorRoles = productSpecAdminRoles.concat(['TDS - BOM Creator', 'TDS - BOM Administrator']);
	const bomEditorRoles = bomCreatorRoles.concat(['TDS - BOM Editor']);
	const artworkCreatorRoles = productSpecAdminRoles.concat(['TDS - Artwork Creator', 'TDS - Artwork Administrator']);
	const recipeCreatorRoles = productSpecAdminRoles.concat(['TDS - Recipe Administrator', 'TDS - Recipe Creator']);
	const recipeEditorRoles = productSpecEditorRoles.concat(['TDS - Recipe Administrator', 'TDS - Recipe Creator', 'TDS - Recipe Editor']);
	const reviewFoodCreatorRoles = productSpecAdminRoles.concat(['TDS - Food Review Creator', 'TDS - Food Review Administrator']);
	const routingRoles = productSpecAdminRoles.concat(['TDS - Routing Creator', 'TDS - Routing Administrator']);
	const specificationDataSheetRoles = productSpecAdminRoles.concat(['TDS - Spec Creator', 'TDS - Spec Administrator']);

	const testRunAdminRoles = ['Test Run Administrator'];
	const testRunEditorRoles = testRunAdminRoles.concat(['Test Run Editor']);

	const formulatedMaterialAdminRoles = ['Formulated Material Administrator'];
	const formulatedMaterialEditorRoles = formulatedMaterialAdminRoles.concat(['Formulated Material Editor']);

	const skuAdminRoles = ['SKU Administrator'];
	const productSampleAdminRoles = ['Sample Administrator'];

	const quoteSupplierAdminRoles = ['Quote Supplier Admin'];
	const sourcingAdminRoles = ['Sourcing Admin'];
	const sourcingLibAdminRoles = ['Sourcing Library Administrator'];
	const supplierAdminRoles = ['Supplier Administrator'];
	const supplierEditRoles = supplierAdminRoles.concat(['Supplier Editor']);
	const supplierRequestAdminRoles = ['Supplier Request Administrator'];
	const supplierRequestEditRoles = supplierRequestAdminRoles.concat(['Supplier Request Editor']);

	const engineeringChangeAdminRoles = ['Engineering Change Administrator'];
	const engineeringChangeEditRoles = engineeringChangeAdminRoles.concat(['Engineering Change Editor']);

	const testRunActionAccess = {
		"Copy": access(full(testRunAdminRoles)),
		"NewTestRun": access(full(testRunAdminRoles)),
		"NewFromContractualDocument": access(full(testRunAdminRoles)),
		"NewFromTestRun": access(full(testRunAdminRoles)),
		"NewFromTemplate": access(full(testRunAdminRoles))
	};

	csiAccess.addViewRoles({
		"_CS_Data": {
			"AllFoods": {
				"Copy": access(full(foodAdmin)),
				"Delete": access(full(foodAdmin)),
				"Edit": access(full(foodEditor)),
				"NewFood": access(full(foodAdmin)),
			},
			"AllFoodHierarchies": {
				"Copy": access(full(hierarchyAdminRoles), full(leafFolderAdminRoles)),
				"Delete": access(full(hierarchyAdminRoles)),
				"Edit": access(full(hierarchyEditRoles)),
				"NewProductHierarchy": access(full(hierarchyAdminRoles)),
				"NewProductHierarchyFolder": access(full(hierarchyAdminRoles), full(leafFolderAdminRoles)),
			},
			"AllFormulatedMaterials": {
				"Copy": access(full(formulatedMaterialAdminRoles)),
				"Delete": access(full(formulatedMaterialAdminRoles)),
				"Edit": access(full(formulatedMaterialEditorRoles)),
				"NewFormulatedMaterial": access(full(formulatedMaterialAdminRoles)),
			},
			"AllFormulatedMaterialHierarchies": {
				"Copy": access(full(hierarchyAdminRoles), full(leafFolderAdminRoles)),
				"Delete": access(full(hierarchyAdminRoles)),
				"Edit": access(full(hierarchyEditRoles)),
				"NewProductHierarchy": access(full(hierarchyAdminRoles)),
				"NewProductHierarchyFolder": access(full(hierarchyAdminRoles), full(leafFolderAdminRoles)),
			},
			"CompetitiveFoods": {
				"NewCompetitiveFood": access(full(productSpecLibAdminRoles)),
				"CopyCompetitiveFood": access(full(productSpecLibAdminRoles)),
				"DeleteCompetitiveFood": access(full(productSpecLibAdminRoles)),
				"EditCompetitiveFood": access(full(productSpecLibAdminRoles))
			},
			"FoodAllergens": {
				"NewFoodAllergen": access(full(productSpecLibAdminRoles)),
				"Copy": access(full(productSpecLibAdminRoles)),
				"Delete": access(full(productSpecLibAdminRoles)),
				"Edit": access(full(productSpecLibAdminRoles))
			},
			"FoodClaims": {
				"NewFoodClaim": access(full(productSpecLibAdminRoles)),
				"Copy": access(full(productSpecLibAdminRoles)),
				"Delete": access(full(productSpecLibAdminRoles)),
				"Edit": access(full(productSpecLibAdminRoles))
			},
			"FoodIngredients": {
				"NewFoodIngredient": access(full(productSpecLibAdminRoles)),
				"Copy": access(full(productSpecLibAdminRoles)),
				"Delete": access(full(productSpecLibAdminRoles)),
				"Edit": access(full(productSpecLibAdminRoles))
			},
			"FoodNutrients": {
				"NewFoodNutrient": access(full(productSpecLibAdminRoles)),
				"Copy": access(full(productSpecLibAdminRoles)),
				"Delete": access(full(productSpecLibAdminRoles)),
				"Edit": access(full(productSpecLibAdminRoles))
			},
			"FoodLabelDataSheetTemplates": {
				"Copy": access(full(productSpecLibAdminRoles)),
				"NewFoodLabelDataSheetTemplate": access(full(productSpecLibAdminRoles))
			},
			"FoodLabelNutrientItemsImportConfigurations": {
				"Copy": access(full(productSpecLibAdminRoles), full(foodLabelEditor)),
				"Delete": access(full(productSpecLibAdminRoles), full(foodLabelEditor)),
				"NewFoodLabelNutrientItemsImportConfiguration": access(full(productSpecLibAdminRoles), full(foodLabelEditor))
			},
			"FoodAndFoodSKUSupplierRequests": {
				"NewSupplierRequest": access(full(supplierRequestAdminRoles))
			},
			"FormulatedMaterialSupplierRequests": {
				"NewSupplierRequest": access(full(supplierRequestAdminRoles))
			},
			"ImpactAnalysis": {
				"NewImpactAnalysis": access(full(engineeringChangeAdminRoles))
			},
			"RecipeItemsImportConfigurations": {
				"Copy": access(full(productSpecLibAdminRoles), full(recipeEditorRoles)),
				"Delete": access(full(productSpecLibAdminRoles), full(recipeEditorRoles)),
				"NewRecipeItemsImportConfiguration": access(full(productSpecLibAdminRoles), full(recipeEditorRoles))
			}
		},
		"Food": {
			"Artworks": {
				"Copy": access(full(artworkCreatorRoles)),
				"Delete": access(full(artworkCreatorRoles)),
				"NewArtwork": access(full(artworkCreatorRoles)),
				"NewFromArtwork": access(full(artworkCreatorRoles))
			},
			"CompetitiveFoods": {
				"NewCompetitiveFood": access(full(productSpecLibAdminRoles)),
				"CopyCompetitiveFood": access(full(productSpecLibAdminRoles)),
				"DeleteCompetitiveFood": access(full(productSpecLibAdminRoles)),
				"EditCompetitiveFood": access(full(productSpecLibAdminRoles))
			},
			"FoodBOMs": {
				"Copy": access(full(bomCreatorRoles)),
				"Delete": access(full(bomCreatorRoles)),
				"NewFoodBOM": access(full(bomCreatorRoles)),
				"NewFromFoodBOM": access(full(bomCreatorRoles))
			},
			"FoodLabelDataSheets": {
				"Copy": access(full(foodLabelCreator)),
				"NewFoodLabelDataSheet": access(full(foodLabelCreator)),
				"NewFromFoodLabelDataSheet": access(full(foodLabelCreator)),
				"NewFromTemplate": access(full(foodLabelCreator)),
				"NewFromRecipeFoodLabel": access(full(foodLabelCreator)),
				"NewFromFoodBOM": access(full(foodLabelCreator))
			},
			"FoodReviews": {
				"Copy": access(full(reviewFoodCreatorRoles)),
				"Delete": access(full(reviewFoodCreatorRoles)),
				"NewReviewFood": access(full(reviewFoodCreatorRoles)),
				"NewFromReviewFood": access(full(reviewFoodCreatorRoles))
			},
			"ProductSamples": {
				"NewFoodSample": access(full(productSampleAdminRoles)),
				"Copy": access(full(productSampleAdminRoles)),
				"Delete": access(full(productSampleAdminRoles))
			},
			"ProductSKU": {
				"Copy": access(full(skuAdminRoles)),
				"NewFoodSKU": access(full(skuAdminRoles))
			},
			"RecipeDataSheets": {
				"Copy": access(full(recipeCreatorRoles)),
				"NewFromRecipeDataSheet": access(full(recipeCreatorRoles)),
				"NewRecipeDataSheet": access(full(recipeCreatorRoles))
			},
			"Routing": {
				"Copy": access(full(routingRoles)),
				"Delete": access(full(routingRoles)),
				"NewRouting": access(full(routingRoles)),
				"NewFromRoutings": access(full(routingRoles)),
				"NewFromTemplate": access(full(routingRoles))
			},
			"SpecificationDataSheets": {
				"Copy": access(full(specificationDataSheetRoles)),
				"Delete": access(full(specificationDataSheetRoles)),
				"NewFromSpecificationDataSheet": access(full(specificationDataSheetRoles)),
				"NewFromTemplate": access(full(specificationDataSheetRoles)),
				"NewSpecificationDataSheet": access(full(specificationDataSheetRoles))
			},
			"TestRuns": testRunActionAccess,
			"WhereUsedApparelBOM": {
				"MassReplace": access(full(foodAdmin)),
				"MassDeletePartMaterials": access(full(foodAdmin))
			}
		},
		"FoodBOMRevision": {
			"HierarchicalBOMLineItems": {
				"RefreshRecipeQty": access(full(bomEditorRoles), full(productSpecEditorRoles))
			}
		},
		"FoodIngredient": {
			"ImpactAnalysis": {
				"NewFoodIngImpactAnalysis": access(full(engineeringChangeAdminRoles)),
				"AddToExistingImpactAnalysis": access(full(engineeringChangeEditRoles))
			}
		},
		"FoodLabelDataSheetRevision": {
			"AllergenItems": {
				"CalculateAllergens": access(full(foodLabelEditor), full(productSpecEditorRoles)),
				"RefreshAllergens": access(full(foodLabelEditor), full(productSpecEditorRoles))
			},
			"ClaimItems": {
				"RefreshClaims": access(full(foodLabelEditor), full(productSpecEditorRoles))
			},
			"FlatIngredientItems": {
				"ResetUniqueFlatIngredients": access(full(foodLabelEditor), full(productSpecEditorRoles)),
			},
			"IngredientItems": {
				"CalculateIngredients": access(full(foodLabelEditor), full(productSpecEditorRoles)),
				"NewIngredientItem": access(full(foodLabelEditor)),
				"ResetIngredients": access(full(foodLabelEditor), full(productSpecEditorRoles))
			},
			"NutrientItems": {
				"CalculateNutrients": access(full(foodLabelEditor), full(productSpecEditorRoles)),
				"RefreshNutrients": access(full(foodLabelEditor), full(productSpecEditorRoles))
			},
		},
		"FoodSKU": {
			"DataPackages":{
				"AggregateFromPackages":access(full(productSpecEditorRoles), full(dataPackageAdminRoles)),
				"NewDataPackage":access(full(productSpecEditorRoles), full(dataPackageAdminRoles)),
				"NewDataPackageFromDataPackageTemplate": access(full(productSpecEditorRoles), full(dataPackageAdminRoles)),
			},
			"FoodSKUReviews": {
				"Copy": access(full(reviewFoodCreatorRoles)),
				"Delete": access(full(reviewFoodCreatorRoles)),
				"NewReviewFoodSKU": access(full(reviewFoodCreatorRoles)),
				"NewFromReviewFoodSKU": access(full(reviewFoodCreatorRoles))
			},
			"SKUArtworks": {
				"Delete": access(full(artworkCreatorRoles)),
				"NewArtwork": access(full(artworkCreatorRoles)),
				"SelectFromArtWorks": access(full(artworkCreatorRoles))
			},
			"SKUSpecDataSheets": {
				"Delete": access(full(specificationDataSheetRoles)),
				"NewSpecificationDataSheet": access(full(specificationDataSheetRoles)),
				"NewSpecificationDataSheetFromTemplate": access(full(specificationDataSheetRoles)),
				"SelectSpecificationDataSheet": access(full(specificationDataSheetRoles))
			},
			"SKUTestRuns": {
				"NewTestRun": access(full(testRunAdminRoles)),
				"SelectFromTestRun": access(full(testRunEditorRoles))
			},
		},
		"FormulatedMaterial": {
			"FoodLabelDataSheets": {
				"NewFoodLabelDataSheet": access(full(foodLabelCreator)),
				"NewFromFoodLabelDataSheet": access(full(foodLabelCreator)),
				"NewFromTemplate": access(full(foodLabelCreator))
			},
			"FoodReviews": {
				"Copy": access(full(reviewFoodCreatorRoles)),
				"Delete": access(full(reviewFoodCreatorRoles)),
				"NewReviewFood": access(full(reviewFoodCreatorRoles)),
				"NewFromReviewFood": access(full(reviewFoodCreatorRoles))
			},
			"ImpactAnalysis": {
				"NewImpactAnalysis": access(full(engineeringChangeAdminRoles)),
				"AddToExistingImpactAnalysis": access(full(engineeringChangeEditRoles))
			},
			"ProductSamples": {
				"Copy": access(full(productSampleAdmin)),
				"NewFormulatedMaterialSample": access(full(productSampleAdmin))
			},
			"RecipeDataSheets": {
				"Copy": access(full(recipeCreatorRoles)),
				"NewFromRecipeDataSheet": access(full(recipeCreatorRoles)),
				"NewRecipeDataSheet": access(full(recipeCreatorRoles))
			},
			"Routing": {
				"Copy": access(full(routingRoles)),
				"Delete": access(full(routingRoles)),
				"NewRouting": access(full(routingRoles)),
				"NewFromRoutings": access(full(routingRoles)),
				"NewFromTemplate": access(full(routingRoles))
			},
			"SpecificationDataSheets": {
				"Copy": access(full(specificationDataSheetRoles)),
				"Delete": access(full(specificationDataSheetRoles)),
				"NewSpecificationDataSheet": access(full(specificationDataSheetRoles)),
				"NewFromSpecificationDataSheet": access(full(specificationDataSheetRoles)),
				"NewFromTemplate": access(full(specificationDataSheetRoles))
			},
			"WhereUsed": {
				"MassAddFormulatedMaterial": access(full(productSpecEditorRoles), full(recipeEditorRoles)),
				"MassReplace": access(full(productSpecEditorRoles), full(recipeEditorRoles)),
				"MassDelete": access(full(productSpecAdminRoles), full(recipeCreatorRoles))
			},
			"TestRuns": testRunActionAccess
		},
		"FormulatedProduct": {
			"ProductSalesRegions": {
				"AggregateFromProductSalesRegions": access(full(productSpecAdminRoles)),
				"Delete": access(full(productSpecAdminRoles))
			},
			"DataSheetIndex": {
				"NewFromOriginalProduct":
					access(full(productSpecAdminRoles), full(recipeCreatorRoles), full(foodLabelCreator), full(bomCreatorRoles), full(artworkCreatorRoles),
						full(reviewFoodCreatorRoles), full(specificationDataSheetRoles), full(routingRoles), full(sourcingLibAdminRoles), full(testRunAdminRoles))
			},
		},
		"Material": {
			"FoodLabelDataSheets": {
				"Copy": access(full(foodLabelCreator)),
				"NewFoodLabelDataSheet": access(full(foodLabelCreator)),
				"NewFromFoodLabelDataSheet": access(full(foodLabelCreator)),
				"NewFromTemplate": access(full(foodLabelCreator)),
			},
			"WhereUsedFoodBOM": {
				"FoodBOMMassReplace": access(full(productSpecEditorRoles), full(bomEditorRoles)),
				"FoodBOMMassAdd": access(full(bomEditorRoles), full(productSpecEditorRoles)),
				"FoodBOMMassDelete": access(full(productSpecAdminRoles), full(recipeCreatorRoles))
			}
		},
		"ProductHierarchyDetails": {
			"Foods": {
				"AggregateFoods": access(full(foodAdmin)),
				"Copy": access(full(foodAdmin)),
				"Delete": access(full(foodAdmin)),
				"MoveToProductHierarchy": access(full(foodAdmin)),
				"NewFood": access(full(foodAdmin)),
				"NewFromFood": access(full(foodAdmin)),
				"Remove": access(full(foodAdmin))
			},
			"FormulatedMaterials": {
				"AggregateFormulatedMaterials": access(full(formulatedMaterialAdminRoles)),
				"Delete": access(full(formulatedMaterialAdminRoles)),
				"MoveToProductHierarchy": access(full(formulatedMaterialAdminRoles)),
				"NewFormulatedMaterial": access(full(formulatedMaterialAdminRoles)),
				"NewFromFormulatedMaterial": access(full(formulatedMaterialAdminRoles)),
				"Remove": access(full(formulatedMaterialAdminRoles))
			},
		},
		"ProductHierarchyLevel": {
			"Foods": {
				"Copy": access(full(foodAdmin)),
				"Delete": access(full(foodAdmin)),
				"Edit": access(full(foodEditor)),
				"Remove": access(full(foodAdmin))
			},
			"FormulatedMaterials": {
				"Delete": access(full(formulatedMaterialAdminRoles)),
				"Edit": access(full(formulatedMaterialEditorRoles))
			}
		},
		"RecipeDataSheetRevision": {
			"Items": {
				"AggregateFromRecipeLineItem": access(full(recipeEditorRoles)),
				"RefreshH2OLoss": access(full(recipeEditorRoles)),
				"NewRecipeLineItem": access(full(recipeEditorRoles)),
				"NewSpecial": access(full(recipeEditorRoles))
			},
			"RecipeBatchItem": {
				"CalculateBatch": access(full(recipeEditorRoles))
			}
		},
		"SupplierRequest": {
			"FoodSamples": {
				"AttachFoodSamples": access(full(sourcingAdminRoles), full(supplierEditRoles), full(quoteSupplierAdminRoles), full(supplierRequestEditRoles)),
				"Copy": access(full(sourcingAdminRoles), full(supplierEditRoles), full(quoteSupplierAdminRoles), full(supplierRequestEditRoles)),
				"NewFoodSample": access(full(sourcingAdminRoles), full(supplierEditRoles), full(quoteSupplierAdminRoles), full(supplierRequestEditRoles))
			},
			"FoodQuotes": {
				"Copy": access(full(sourcingAdminRoles), full(supplierEditRoles), full(quoteSupplierAdminRoles), full(supplierRequestEditRoles)),
				"Delete": access(full(sourcingAdminRoles), full(supplierEditRoles), full(quoteSupplierAdminRoles), full(supplierRequestEditRoles)),
				"NewQuote": access(full(sourcingAdminRoles), full(supplierEditRoles), full(quoteSupplierAdminRoles), full(supplierRequestEditRoles)),
				"MassApproveSupplierItems": access(full(sourcingAdminRoles), full(supplierEditRoles), full(quoteSupplierAdminRoles), full(supplierRequestEditRoles)),
				"MassAbandonSupplierItems": access(full(sourcingAdminRoles), full(supplierEditRoles), full(quoteSupplierAdminRoles), full(supplierRequestEditRoles)),
				"MassDeleteSupplierItems": access(full(sourcingAdminRoles), full(supplierEditRoles), full(quoteSupplierAdminRoles), full(supplierRequestEditRoles)),
				"MassReopenSupplierItems": access(full(sourcingAdminRoles), full(supplierEditRoles), full(quoteSupplierAdminRoles), full(supplierRequestEditRoles)),
				"MassReviseSupplierItems": access(full(sourcingAdminRoles), full(supplierEditRoles), full(quoteSupplierAdminRoles), full(supplierRequestEditRoles))
			}
		},
		"Style": {
			"FoodLabelDataSheets": {
				"Copy": access(full(foodLabelCreator)),
				"NewFoodLabelDataSheet": access(full(foodLabelCreator)),
				"NewFromFoodLabelDataSheet": access(full(foodLabelCreator)),
				"NewFromTemplate": access(full(foodLabelCreator))
			},
		}
	});
});